import { useState, useRef, useCallback, useEffect } from "react"

export function useAudioPlayer(){

    const [isPlayingState, setIsPlaying] = useState<boolean>(false)
    const [duration, setDuration] = useState<number>(100)
    const [curTime, setCurTime] = useState(0)
    let audio = useRef<HTMLAudioElement>()

    const setAudioData = () => {
        setDuration(audio.current!.duration);
       // setCurTime(audio.currentTime);
      }

    const setAudioTime = ()=>{
        setCurTime(audio.current!.currentTime)
    }  

    const audioRef = useCallback((node: HTMLAudioElement)=>{

        if(node) {
            //setDuration(0) // Commented this as React router coudn't isten for route change for this..not sure why?
            audio.current = node
            audio.current!.addEventListener("loadedmetadata", setAudioData);
            audio.current!.addEventListener('ended', ()=>{
                setIsPlaying(false)
                setCurTime(0)
            })
            //audio.addEventListener('loadeddata', playAudio)
        }

    },[])

    function playAudio(){

        audio.current?.play()
        setIsPlaying(true)
    }

    function pauseAudio(){

        audio.current?.pause()
        setIsPlaying(false)
    }

    useEffect(()=>{

        audio.current?.addEventListener("timeupdate", setAudioTime);

        return ()=>{
            audio.current?.removeEventListener("timeupdate", setAudioTime)
        }
    })

    return {
        isPlayingState,
        duration,
        setDuration,
        audioRef,
        playAudio,
        pauseAudio,
        curTime
    }

}